import moment from 'moment';
import PropTypes from 'prop-types';
import add from 'ramda/es/add';
import React, { useReducer } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import styles from '@client/containers/donationsCard/donationList/donationList.scss';
import styleHelper from '@client/shared/styles/styleHelper.scss';

export default function DonationList({ donations }) {
  const [numDisplay, viewMore] = useReducer(add(3), 3);

  return (
    <div className={styles.donationList}>
      {donations.slice(0, numDisplay).map((donation, i) => {
        return (
          <div className={styles.donationEntry} key={i}>
            <span>
              <span className={styles.name}>
                {getIn(donation, 'anonymousDonation')
                  ? 'Anonym givare '
                  : getIn(donation, 'donorType') === 'Company'
                  ? `${getIn(donation, 'donorCompanyName')} `
                  : `${getIn(donation, 'donorFirstName')} ${getIn(
                      donation,
                      'donorLastName'
                    )} `}
              </span>
              <span className={styles.amount}>
                {getIn(donation, 'donatedAmount')} kr{' '}
              </span>
            </span>
            <span className={styles.date}>
              {moment(getIn(donation, 'created')).format('YYYY-MM-DD')}
            </span>
          </div>
        );
      })}
      {donations.size > numDisplay && (
        <a className={styleHelper.hlfLink} onClick={viewMore}>
          Visa fler
        </a>
      )}
    </div>
  );
}

DonationList.propTypes = {
  donations: ImmutablePropTypes.listOf(
    ImmutablePropTypes.mapContains({
      id: PropTypes.string,
      donatedAmount: PropTypes.number,
      created: PropTypes.string,
      donorFirstName: PropTypes.string,
      donorLastName: PropTypes.string,
      anonymousDonation: PropTypes.bool,
    })
  ),
};
